module.exports = __webpack_public_path__ + "../resources/img/ic_camera_switch_default.83b81087.svg";